import { Button, Flex, Result, Typography, theme } from 'antd';
import { Link, Navigate, useSearchParams } from 'react-router';
import { ReenviarVerificacao } from './ReenviarVerificacao';
import { comDestino, useDestino } from './destino';
import { emailDaVerificacao, retornoDoEmail } from './verificacao';

/**
 * "Confirme seu e-mail": a tela que o cadastro entrega, agora com endereço.
 *
 * O porquê de ser rota está no `verificacao.ts`, junto da função que monta o
 * endereço. Aqui só se lê o que ele carrega.
 *
 * **Fora do `RedirectIfAuthenticated`, como a `/nova-senha`.** Quem acabou de
 * se cadastrar não tem sessão (a conta exige confirmação), mas quem chega por
 * um link antigo pode ter - e ser expulso para a Home no meio de uma instrução
 * seria voltar ao problema que esta tela existe para resolver.
 */
export function VerifiqueOEmailPage() {
  const { token } = theme.useToken();
  const [busca] = useSearchParams();
  const destino = useDestino();
  const email = emailDaVerificacao(busca.get('email'));

  // Sem e-mail não há o que reenviar nem a quem se dirigir.
  if (!email) return <Navigate to={comDestino('/entrar', destino)} replace />;

  return (
    <Result
      style={{ padding: 0 }}
      status="success"
      title="Confirme seu e-mail"
      subTitle={`Enviamos um link de confirmação para ${email}. Abra a mensagem para ativar sua conta.`}
      extra={
        <Flex vertical gap={token.margin} style={{ width: '100%' }}>
          {/* O destino atravessa a confirmação de e-mail: quem veio comprar
              continua indo para os planos depois de entrar. */}
          <Link to={comDestino('/entrar', destino)}>
            <Button type="primary" size="large" block>
              Ir para o login
            </Button>
          </Link>
          <ReenviarVerificacao email={email} retorno={retornoDoEmail(destino)} />
          <Typography.Text type="secondary" style={{ textAlign: 'center', fontSize: 12 }}>
            A mensagem pode levar alguns minutos e às vezes cai no spam.
          </Typography.Text>
        </Flex>
      }
    />
  );
}
